import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { useForm } from "react-hook-form";
import LossPreventionForm from "./LossPreventionForm";
import "./reportform.css"
import { Promotionform } from "../TicketCreate/Promotionform";
import PropertyForm from "./PropertyForm";
import AutoForm from "./AutoForm";
import IncidentForm from "./IncidentForm";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast, Toaster } from "sonner";
import CustomerInjusry from "./CustomerInjusry";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';



const FormItem = ({ label, value, full = false }) => (
  <div className={full ? "md:col-span-2" : ""}>
    <label className="block text-sm text-gray-600 mb-1">{label}</label>
    <div className=" p-3 rounded-md border border-gray-300 text-sm whitespace-pre-wrap">
      {value || "-"}
    </div>
  </div>
);


const ClaimReport = () => {

  const [lossFormData, setLossFormData] = React.useState({});
  const [propertyFormData, setPropertyFormData] = React.useState({});
  const [autoFormData, setAutoFormData] = React.useState({});
  const [incidentFormData, setIncidentFormData] = React.useState({});

  const [loading, setLoading] = React.useState(false);

  const [lossform, setLossform] = React.useState(false);
  const [propertyform, setPropertyform] = React.useState(false);
  const [autoform, setAutoform] = React.useState(false);
  const [incidentform, setIncidentform] = React.useState(false);
  const [currentStep, setCurrentStep] = React.useState(1);
  const [storeid, setstoreid] = React.useState()
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const Navigate = useNavigate();
  const store_email = sessionStorage.getItem('email');
  const store_id = sessionStorage.getItem("store_id");
  // const [phoneNumber, setPhoneNumber] = useState(defaultValues?.witness_phone || '');

  useEffect(() => {
    console.log("useEffect triggered for fetchData");
    const fetchData = async () => {
      try {
        const response = await fetch(`/server/mitra-integration/api/get-all-sales`);
        const data = await response.json();
        // console.log("Fetched store data:", data[0].Restaurant);


      } catch (error) {
        console.error("Upload failed:", error);
      }
    };

    fetchData();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' }); // e.g., Jun
    const year = date.getFullYear();
    return `${day}:${month}:${year}`;
  };
  const goNext = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const goBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  // const onSubmit = (data) => {
  //     console.log("Submitted Data:", data);
  //     alert("Report Submitted!");
  // };

  useEffect(() => {
    console.log("loss form data:", lossFormData);
    console.log("propert data", propertyFormData)
    console.log("Injury form Data", autoFormData)
    console.log("incidentform Data", incidentFormData)

  }, [lossFormData, propertyFormData, autoFormData, incidentFormData]);


  const handleLossSubmit = async () => {
    setLoading(true);
    const finalPayload = {
      ...lossFormData,
      store_email: store_email,
      store_id: store_id
    };


    console.log("final payload losssumbit", finalPayload)

    try {
      const response = await axios.post('/server/forms/loss-prevention-incident', finalPayload);
      console.log('Submitted data:', response.data);
      
      if (response.data.emailSent) {
        toast.success(`Form Submitted Successfully! Email sent to ${response.data.emailRecipient}`);
      } else {
        toast.success("Form Submitted Successfully!");
        if (response.data.emailError) {
          toast.warning(`Note: Email notification failed - ${response.data.emailError}`);
        }
      }

      // ✅ Instead of navigating, show a confirmation step
      setCurrentStep(1);

    } catch (error) {
      console.error('Submission error:', error);
      toast.error('An error occurred while submitting the report.');
    } finally {
      setLoading(false);
    }
  };







  const handlePropertySubmit = async () => {
    setLoading(true);

    // Add store_email and store_id to the payload
    const finalPayload = {
      ...propertyFormData,
      store_email,
      store_id
    };
    console.log("final payload propertysumbit", finalPayload)
    try {
      const response = await axios.post('/server/forms/property-loss-notice', finalPayload);
      console.log('Submitted data:', response.data);
      
      if (response.data.emailSent) {
        toast.success(`Form Submitted Successfully! Email sent to ${response.data.emailRecipient}`);
      } else {
        toast.success("Form Submitted Successfully!");
        if (response.data.emailError) {
          toast.warning(`Note: Email notification failed - ${response.data.emailError}`);
        }
      }
      
      setCurrentStep(1);
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('An error occurred while submitting the report.');
    } finally {
      setLoading(false);
    }
  };





  const handleincidentSubmit = async () => {
    setLoading(true);


    const finalPayload = {
      ...autoFormData,
      store_email,
      store_id
    };
    console.log("final payload handle incident sumbit", finalPayload)
    try {
      const response = await axios.post('/server/forms/customer-injury', finalPayload);
      console.log('Submitted data:', response.data);
      
      if (response.data.emailSent) {
        toast.success(`Form Submitted Successfully! Email sent to ${response.data.emailRecipient}`);
      } else {
        toast.success("Form Submitted Successfully!");
        if (response.data.emailError) {
          toast.warning(`Note: Email notification failed - ${response.data.emailError}`);
        }
      }
      
      setCurrentStep(1);
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('An error occurred while submitting the report.');
    } finally {
      setLoading(false);
    }
  };


  const handleteamMemberSubmit = async () => {
    setLoading(true);

    const finalPayload = {
      ...incidentFormData,
      store_email,
      store_id
    };
    console.log("final payload team sumbit", finalPayload)
    try {
      const response = await axios.post('/server/forms/team-member-injury', finalPayload);
      console.log('Submitted data:', response.data);
      
      if (response.data.emailSent) {
        toast.success(`Form Submitted Successfully! Email sent to ${response.data.emailRecipient}`);
      } else {
        toast.success("Form Submitted Successfully!");
        if (response.data.emailError) {
          toast.warning(`Note: Email notification failed - ${response.data.emailError}`);
        }
      }
      
      setCurrentStep(1);
    } catch (error) {
      console.error('Submission error:', error);
      toast.error('An error occurred while submitting the report.');
    } finally {
      setLoading(false);
    }

  }






  // --- Step Components ---
  const StepOne = () => (
    <div>
      <h3> Please select the appropriate claim type fro the incident you are reporting. if the incident you are reporting is critical <span className="text-[#EF7320] font-bold">STOP</span> and call in the claim x-xxxx-xxx-xxxx</h3>
      <div >
        <h3 className="font-bold pt-2">Please Note :</h3>
        <div className="pt-1">
          <p> ●  If you are reporting property damage use the Property Loss Notice Form. </p>
          <p> ●  If you are reporting injury to a team member use the Team Member Incident Report.</p>
          <p> ●  If you are reporting anything related to a Guest use the Guest Incident Report form.</p>
          <p> ●  All other issues, please use the Loss Prevention Report. If in doubt, use the incident report.</p>
        </div>

      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 text-center">
        <div className=" shadow-md rounded-lg p-4 text-center border border-[#EF7320] bg-[#f7c7a7] text-[#EF7320] font-bold hover:bg-[#EF7320] hover:text-white hover:border-0" onClick={() => { setPropertyform(true); setLossform(false); setAutoform(false); setIncidentform(false); goNext(); }}>Property Loss Notice</div>
        <div className=" shadow-md rounded-lg p-4 text-center border border-[#EF7320] bg-[#f7c7a7] text-[#EF7320] font-bold hover:bg-[#EF7320] hover:text-white hover:border-0" onClick={() => { setAutoform(true); setPropertyform(false); setLossform(false); setIncidentform(false); goNext(); }}>Team Member Incident</div>
        <div className=" shadow-md rounded-lg p-4 text-center border border-[#EF7320] bg-[#f7c7a7] text-[#EF7320] font-bold hover:bg-[#EF7320] hover:text-white hover:border-0" onClick={() => { setIncidentform(true); setPropertyform(false); setLossform(false); setAutoform(false); goNext(); }}>Guest Incident</div>
        <div className=" shadow-md rounded-lg p-4 text-center border border-[#EF7320] bg-[#f7c7a7] text-[#EF7320] font-bold hover:bg-[#EF7320] hover:text-white hover:border-0" onClick={() => { setLossform(true); setAutoform(false); setIncidentform(false); setPropertyform(false); goNext(); }}>Loss Prevention </div>



      </div>



    </div>
  );

  const StepTwo = () => {
    if (lossform) return <LossPreventionForm
      onReview={(data) => {
        setLossFormData(data);
        goNext();
      }}
      goBack={goBack}
      defaultValues={lossFormData}
    />
    if (propertyform) return <PropertyForm onReview={(data) => { setPropertyFormData(data); goNext(); }} goBack={goBack} defaultValues={propertyFormData} />;
    if (autoform) return <CustomerInjusry onReview={(data) => { setAutoFormData(data); goNext(); }} goBack={goBack} defaultValues={autoFormData} />;
    if (incidentform) return <IncidentForm onReview={(data) => { setIncidentFormData(data); goNext(); }} goBack={goBack} defaultValues={incidentFormData} />;
    return <p>Please select a claim type to proceed.</p>;
  };


  const StepThree = () => (
    <div>
      <h3 className="text-lg font-semibold text-[#EF7320] mb-4">Please review your information before submission</h3>
      <ul className="list-disc pl-4 text-sm text-gray-700 space-y-1">
        {lossform && (
          <form className="space-y-4 bg-white border p-6 rounded-lg shadow-sm max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-[#EF7320] mb-6">LOSS REPORT</h2>

            {/* Section: Loss Details */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Loss Details</h3>
              <div className="grid gap-4 md:grid-cols-3 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Store Number</label>
                  <div className=" h-10 border border-gray-300 h-10 rounded-md p-2 text-sm   w-full border border-gray-300 rounded-md p-2">{lossFormData.store_id}</div>
                </div>
                <div>
                  <label className="text-gray-600 text-sm">Incident Type</label>
                  <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm requied  ">{lossFormData.incident_type}</div>
                </div>


                {lossFormData.incident_type === "Other" && (
                  <div>
                    <label className="text-gray-600 text-sm">Other</label>
                    <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   ">
                      {lossFormData.other}
                    </div>
                  </div>
                )}
                <div>
                  <label className="text-gray-600 text-sm">Incident Date</label>
                  <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   ">
                    {formatDate(lossFormData.incident_date)}
                  </div>
                </div>
                <div>
                  <label className="text-gray-600 text-sm">Incident Time</label>
                  <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">
                    {new Date(lossFormData.incident_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>




              </div>
              <div className="grid gap-4 md:grid-cols-3 mt-3 grid-cols-1">

                <div>
                  <label className="text-gray-600 text-sm">Authorities Called?</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {lossFormData.authoritiesCalled}
                  </div>
                </div>
                {lossFormData.authoritiesCalled === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">Responding Authority Name</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{lossFormData.
                        responding_authority
                      }</div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Report Number</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{lossFormData.report_number}</div>
                    </div>
                  </>
                )}
              </div>



            </div>

            {/* Section: Description */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Description</h3>
              <div className=" border border-gray-300 p-4 rounded-md whitespace-pre-wrap">
                {lossFormData.incident_description}
              </div>
            </div>

            {/* Section: Witness */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Witness</h3>

              {/* Display witness value */}
              <div className="grid gap-4 md:grid-cols-3 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Was there a witness?</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {lossFormData?.witness || 'N/A'}
                  </div>
                </div>
              </div>

              {/* Conditional fields if witness === "Yes" */}
              {lossFormData?.witness === "Yes" && (
                <div className="grid gap-4 md:grid-cols-3 grid-cols-1 mt-4">
                  <div>
                    <label className="text-gray-600 text-sm">Name</label>
                    <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                      {lossFormData?.witness_name || 'N/A'}
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm">Email</label>
                    <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                      {lossFormData?.witness_email || 'N/A'}
                    </div>
                  </div>
                  <div>
                    <label className="text-gray-600 text-sm">Primary Phone Home</label>
                    <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                      {lossFormData?.witness_phone || 'N/A'}
                    </div>
                  </div>
                </div>
              )}
            </div>




            {/* Section: Report Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Report Information</h3>
              <div className="grid gap-4 md:grid-cols-3 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Reported By</label>
                  <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{lossFormData.reported_by
                  }</div>
                </div>
                <div>
                  <label className="text-gray-600 text-sm">Reported Date</label>
                  <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">
                    {formatDate(lossFormData.reported_date)}</div>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex row justify-start mt-4 gap-2">
              <button
                type="button"
                onClick={() => handleLossSubmit()}
                className="bg-[#EF7320] text-white py-2 px-4 rounded-md hover:bg-orange-600 transition-colors duration-200"
              >
                Submit Report
              </button>
              <button
                type="button"
                onClick={goBack}
                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 transition-colors duration-200"
              >
                Back
              </button>
            </div>
          </form>
        )}








        {propertyform && (

          <form className="space-y-4 bg-white border p-6 rounded-lg shadow-sm max-w-5xl mx-auto">
            <h2 className="text-2xl font-bold text-[#EF7320] mb-6">PROPERTY LOSS REPORT</h2>
            {/* Section: Summary */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Summary</h3>
              <div className="border border-gray-300 p-4 rounded-md whitespace-pre-wrap">
                {propertyFormData.property_summary}
              </div>
            </div>

            {/* Section: Driver Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Driver Information</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Driver Involved</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.driver_info}
                  </div>
                </div>
                {propertyFormData.driver_info === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">Driver Name</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.driver_name}
                      </div>
                    </div>
                    <div className="md:col-span-2">
                      <label className="text-gray-600 text-sm">Driver Address</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.driver_street}, {propertyFormData.driver_city}, {propertyFormData.driver_state} {propertyFormData.driver_zip}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section: Insurance Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Insurance Information</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Insurance Info</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.insurance_info}
                  </div>
                </div>
                {propertyFormData.insurance_info === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">Insurance Company</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.insurance_company_name}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Policy Number</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.insurance_policy}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section: Vehicle Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Vehicle Information</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Vehicle Involved</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.vechile_info}
                  </div>
                </div>
                {propertyFormData.vechile_info === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">License State</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.state_of_license}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Plate Number</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.license_plate_no}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section: Witness Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Witness Information</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Witness Present</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.witness}
                  </div>
                </div>
                {propertyFormData.witness === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">Witness Name</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.witness_name}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Witness Email</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.witness_email}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Witness Phone</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.witness_phone}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section: Authorities Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Authority Response</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Authorities Called</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.authoritiesCalled}
                  </div>
                </div>
                {propertyFormData.authoritiesCalled === "Yes" && (
                  <>
                    <div>
                      <label className="text-gray-600 text-sm">Responding Authority</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.responding_authority}
                      </div>
                    </div>
                    <div>
                      <label className="text-gray-600 text-sm">Report Number</label>
                      <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                        {propertyFormData.report_number}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section: Report Info */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-700 mb-2">Report Information</h3>
              <div className="grid gap-4 md:grid-cols-2 grid-cols-1">
                <div>
                  <label className="text-gray-600 text-sm">Reported By</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {propertyFormData.reported_by}
                  </div>
                </div>
                <div>
                  <label className="text-gray-600 text-sm">Reported Date</label>
                  <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                    {formatDate(propertyFormData.reported_date)}
                  </div>
                </div>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex row justify-start mt-4 gap-2">
              <button
                type="button"
                onClick={() => handlePropertySubmit()}
                className="bg-[#EF7320] text-white py-2 px-4 rounded-md hover:bg-orange-600 transition-colors duration-200"
              >
                Submit Report
              </button>
              <button
                type="button"
                onClick={goBack}
                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 transition-colors duration-200"
              >
                Back
              </button>
            </div>
          </form>

        )}



        {autoform && (
          <div className="space-y-4 bg-white border p-6 rounded-lg shadow-sm">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-gray-600 text-sm">Gender</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.gender}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Glasses</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.glasses}</div>
              </div>
              <div>
                <label className="text-gray-600 text-sm">Walking Device</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.walking_device}</div>
              </div>
              <div>
                <label className="text-gray-600 text-sm">Customer Name</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.customer_name}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Customer City</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.customer_city}</div>
              </div>



              <div>
                <label className="text-gray-600 text-sm">Customer State</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.customer_state}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Customer Zip-Code</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.zip_code}</div>
              </div>

              <div >
                <label className="text-gray-600 text-sm">Customer Phone Number</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.country_code} {autoFormData.customer_phone}
                </div>
              </div>

              <div >
                <label className="text-gray-600 text-sm">Customer Email</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.customer_email}
                </div>
              </div>

              <div >
                <label className="text-gray-600 text-sm">Area Dry</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.area_dry}
                </div>
              </div>

              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Accident Description</label>
                <div className=" border border-gray-300 h-auto rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.accident_description}
                </div>
              </div>


              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Is anything on the floor</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.on_the_floor}

                </div>

                {autoFormData.on_the_floor === "Yes" && (
                  <>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Floor Description</label>
                      <div className=" border border-gray-300 h-auto rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {autoFormData.floor_description}
                      </div>
                    </div>
                  </>
                )}

              </div>



              <div >
                <label className="text-gray-600 text-sm">Specific Area Incident Occurred</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.incident_occured}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Body Part injuried</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.body_part_injured}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Which Side of Body Part</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.which_side_of_the_body}
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Authorities Called</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.authoritiesCalled}
                </div>

                {autoFormData.authoritiesCalled === "Yes" && (
                  <>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Authorities Name</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {autoFormData.responding_authority}
                      </div>
                    </div>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Authorities Phone Number</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {autoFormData.report_number}
                      </div>
                    </div>
                  </>
                )}
              </div>


              <div >
                <label className="text-gray-600 text-sm">Employee Arrived at</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {/* {autoFormData.employee_arrived_time} */}
                  {new Date(autoFormData.employee_arrived_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>


              <div>
                <label className="text-gray-600 text-sm">Is FirstAid Provided</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.first_aid_provided}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Ambulance Transport Called</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.ambulance_transport_called}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Is FirstAid Provided</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {autoFormData.first_aid_provided}
                </div>
              </div>



              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Reported By</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{autoFormData.reported_by}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Reported Date</label>
                <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                  {formatDate(autoFormData.reported_date)}
                </div>
              </div>


            </div>


            {/* Buttons */}
            <div className="flex row justify-start mt-4 gap-2">
              <button
                type="button"
                onClick={() => handleincidentSubmit()}
                className="bg-[#EF7320] text-white py-2 px-4 rounded-md hover:bg-orange-600 transition-colors duration-200"
              >
                Submit Report
              </button>
              <button
                type="button"
                onClick={goBack}
                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 transition-colors duration-200"
              >
                Back
              </button>
            </div>
          </div>
        )}





        {incidentform && (
          <div className="space-y-4 bg-white border p-6 rounded-lg shadow-sm">

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-gray-600 text-sm">Gender</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.gender}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Glasses</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.glasses}</div>
              </div>
              <div>
                <label className="text-gray-600 text-sm">Walking Device</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.walking_device}</div>
              </div>
              <div>
                <label className="text-gray-600 text-sm">Customer Name</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.customer_name}</div>
              </div>

              {/* <div>
                <label className="text-gray-600 text-sm">Customer DOB</label>
                <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                  {formatDate(incidentFormData?.date_of_birth)}
                </div>
              </div> */}

              <div>
                <label className="text-gray-600 text-sm">Customer City</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.customer_city}</div>
              </div>



              <div>
                <label className="text-gray-600 text-sm">Customer State</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.customer_state}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Customer Zip-Code</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.zip_code}</div>
              </div>

              <div >
                <label className="text-gray-600 text-sm">Customer Phone Number</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.country_code} {incidentFormData.customer_phone}
                </div>
              </div>

              <div >
                <label className="text-gray-600 text-sm">Customer Email</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.customer_email}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Area Dry</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.area_dry}
                </div>
              </div>

              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Accident Description</label>
                <div className=" border border-gray-300 h-auto rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.accident_description}
                </div>
              </div>


              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Is anything on the floor</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.on_the_floor}

                </div>

                {incidentFormData.on_the_floor === "Yes" && (
                  <>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Floor Description</label>
                      <div className=" border border-gray-300 h-auto rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {incidentFormData.floor_description}
                      </div>
                    </div>
                  </>
                )}

              </div>



              <div >
                <label className="text-gray-600 text-sm">Specific Area Incident Occurred</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.incident_occured}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Body Part injuried</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.body_part_injured}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Which Side of Body Part</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.which_side_of_the_body}
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Authorities Called</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.authoritiesCalled}
                </div>

                {incidentFormData.authoritiesCalled === "Yes" && (
                  <>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Authorities Name</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {incidentFormData.responding_authority}
                      </div>
                    </div>
                    <div className="md:col-span-2 mt-2">
                      <label className="text-gray-600 text-sm">Authorities Phone Number</label>
                      <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                        {incidentFormData.report_number}
                      </div>
                    </div>
                  </>
                )}
              </div>





              <div>
                <label className="text-gray-600 text-sm">Is FirstAid Provided</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.first_aid_provided}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Ambulance Transport Called</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.ambulance_transport_called}
                </div>
              </div>
              <div >
                <label className="text-gray-600 text-sm">Is FirstAid Provided</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm   whitespace-pre-wrap">
                  {incidentFormData.first_aid_provided}
                </div>
              </div>



              <div className="md:col-span-2">
                <label className="text-gray-600 text-sm">Reported By</label>
                <div className=" border border-gray-300 h-10 rounded-md p-2 text-sm  ">{incidentFormData.reported_by}</div>
              </div>

              <div>
                <label className="text-gray-600 text-sm">Reported Date</label>
                <div className="border border-gray-300 h-10 rounded-md p-2 text-sm">
                  {formatDate(incidentFormData.reported_date)}
                </div>
              </div>


            </div>


            {/* Buttons */}
            <div className="flex row justify-start mt-4 gap-2">
              <button
                type="button"
                onClick={() => handleteamMemberSubmit()}
                className="bg-[#EF7320] text-white py-2 px-4 rounded-md hover:bg-orange-600 transition-colors duration-200"
              >
                Submit Report
              </button>
              <button
                type="button"
                onClick={goBack}
                className="bg-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-400 transition-colors duration-200"
              >
                Back
              </button>
            </div>
          </div>
        )}


      </ul>
    </div>

  );
  return (


    <Sidebar>

      <Toaster position="top-center" richColors closeButton />
      {loading && (
        <div className="flex justify-center items-center h-full min-h-[300px]">
          <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320]  border-solid"></div>
        </div>
      )}

      <form className="p-6  mx-auto w-full">
        {/* Stepper */}
        <ol className="flex justify-around items-center w-full p-3 text-sm font-medium text-gray-500 bg-white border border-gray-200 rounded-lg shadow-sm sm:text-base sm:p-4 rtl:space-x-reverse">

          {["Claim", "Fill Out", "Next Steps"].map((label, index) => {
            const step = index + 1;
            const isActive = currentStep === step;
            const isCompleted = currentStep > step;

            return (
              <li key={step} className={`flex items-center ${isActive ? "text-[#EF7320]" : "text-green-500"}`}>
                <span
                  className={`flex items-center justify-center w-6 h-6 me-2 text-xs border rounded-full shrink-0 ${isActive
                    ? "border-[#EF7320] text-[#EF7320]"
                    : isCompleted
                      ? "border-green-500 text-green-500"
                      : "border-gray-400"
                    }`}
                >
                  {step}
                </span>
                {label}
                {step < 3 && (
                  <svg
                    className="w-3 h-3 ms-2 sm:ms-4 rtl:rotate-180"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 12 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m7 9 4-4-4-4M1 9l4-4-4-4"
                    />
                  </svg>
                )}
              </li>
            );
          })}
        </ol>

        {/* Step Content */}
        <div className="mt-1 bg-white p-6 rounded-lg shadow-md min-h-[200px] ">
          {currentStep === 1 && <StepOne />}
          {currentStep === 2 && <StepTwo />}
          {currentStep === 3 && <StepThree />}
        </div>

      </form>
    </Sidebar>
  );
};

export default ClaimReport;
